import { schema } from 'normalizr';

const learningQuestionSchema = new schema.Entity('learningQuestions', {});

export default learningQuestionSchema;
